import { createContext, useContext } from "react";
import { CANONICAL_DOMAIN } from "../content/site";

// Idioma derivado de la URL: /en/... = inglés, resto = español.
export const LangContext = createContext("es");
export const useLang = () => useContext(LangContext);

// useLp() devuelve una función que prefija /en a las rutas internas
// cuando el idioma activo es inglés. lp("/servicios/") -> "/en/servicios/".
export const useLp = () => {
  const lang = useLang();
  return (path) => (lang === "en" ? `/en${path}` : path);
};

// URL absoluta canónica de una ruta en el idioma indicado.
export const localeUrl = (lang, path) =>
  `${CANONICAL_DOMAIN}${lang === "en" ? "/en" : ""}${path}`;
